import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var SecaService = /** @class */ (function () {
    function SecaService(http) {
        this.http = http;
        this.cargadoSeca = true;
        this.seca = [];
        this.secaRFL = [];
        this.secaRFC = [];
        this.secaRFP = [];
        this.secaRCL = [];
        this.secaRCC = [];
        this.secaRCP = [];
        this.cargarSeca();
    }
    SecaService.prototype.cargarSeca = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.seca = resp;
                console.log(_this.seca);
                _this.secaRFL = _this.seca[9].rutinafacial.limpieza;
                _this.secaRFC = _this.seca[9].rutinafacial.cuidado;
                _this.secaRFP = _this.seca[9].rutinafacial.proteccion;
                _this.secaRCL = _this.seca[9].rutinacorporal.limpieza;
                _this.secaRCC = _this.seca[9].rutinacorporal.cuidado;
                _this.secaRCP = _this.seca[9].rutinacorporal.proteccion;
                setTimeout(function () {
                    _this.cargadoSeca = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    SecaService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SecaService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], SecaService);
    return SecaService;
}());
export { SecaService };
//# sourceMappingURL=seca.service.js.map